export const defaultProfileImage =
  "https://dbt1op7sh4doh.cloudfront.net/dashboard/1741547042388_1741547042386-77039578-Mask%20Group%202.png";
